import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'SidebarNav' };

import { computed } from '@vue';

import { useGetter } from '@store';

import { DashboardMenuItem } from '@values/dashboard-menus';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const menu = useGetter('dashboardMenu');
const activeRole = useGetter('activeRole');

const items = computed(() => {
  const keyPrefix = activeRole.value?.id ?? 0;

  return menu.value
    .filter(({ sub }) => !sub)
    .map(({ id, label, route, icon, comingSoon }, i) => {
      // Nav item key.
      const key = `${keyPrefix}-${id}`;
      // Nav item target.
      const to = { name: route };
      // Nav item style.
      const style = { transitionDelay: `${0.04 * i}s` };

      const link = { key, to, style };

      return { key, label, icon, link, comingSoon };
    });
});

const navItemTooltip = (item: DashboardMenuItem) => {
  return item.comingSoon ? 'Coming Soon!' : null;
};

return { __sfc: true,menu, activeRole, items, navItemTooltip }
}

})